import styled from "styled-components";

export const ContainerClassroom = styled.div`
    @media (max-width: 750px) {
       flex-direction: column;

       .classroom-header{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
       }
  }
h2{
    font-size: 22px;
    line-height: 26px;
    color: #fff;
    text-align: left;
    width: 100%;
    max-width:1000px;
    padding: 15px 30px;

    @media (max-width: 750px) {
        font-size: 16px;
    line-height: 20px;
    text-align: center;
  }
}
`;